import type { Settlement, SettlementJobs } from '../types';

export function buildJobCounts(settlement: Settlement): SettlementJobs {
    const counts: SettlementJobs = {
        lumberjacks: 0,
        assistants: 0,
        sawmillers: 0,
        foresters: 0,
        farmers: 0,
        hunters: 0,
        fishers: 0,
        smokers: 0,
        weavers: 0,
        smiths: 0,
        goldMiners: 0,
        minters: 0,
        builders: 0,
        quarrymen: 0,
        masons: 0,
        burners: 0,
        miners: 0,
        smelters: 0,
        militia: 0,
    };
    settlement.people.forEach((person) => {
        if (!person.job) return;
        counts[person.job] += 1;
    });
    return counts;
}

export function syncJobsFromPeople(settlement: Settlement): void {
    settlement.jobs = buildJobCounts(settlement);
}
